import React from 'react';
import _ from 'lodash';

import {
  makeVar,
  useReactiveVar
} from '@apollo/client';
import {
  Alert,
  AlertColor,
  AlertTitle,
  Box
} from '@mui/material';



export interface IAlert {
  severity: AlertColor;
  message: string;
}

export interface IState {
  alerts: IAlert[];
}

export const makeAlert = makeVar<IState>({
  alerts: []
});

export function sendAlert(alert: IAlert) {
  const existing = makeAlert();
  const alerts = [
    ...existing.alerts,
    alert
  ];
  makeAlert({
    alerts
  });

  setTimeout(() => {
    const toPop = makeAlert();
    if (!_.isEmpty(toPop.alerts) && toPop.alerts.shift()) {
      makeAlert({
        alerts: [
          ...toPop.alerts
        ]
      });
    }
  }, 5000);
}



export const FC = () => {
  const { alerts } = useReactiveVar(makeAlert);




  return (
    <Box sx={{
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column-reverse',
      top: '50vh',
      minWidth: '25vw',
      pointerEvents: 'none',
      right: theme => theme.spacing(1),
      bottom: theme => theme.spacing(1)
    }}>
      {alerts.map((alert, i) => (
        <Alert
          variant="filled"
          key={i}
          severity={alert.severity}>
          <AlertTitle>{_.startCase(alert.severity)}</AlertTitle>
          {alert.message}
        </Alert>
      ))}
    </Box>
  );
};
